/**
 * CMS 미디어(이미지·영상) 서빙 base URL — **모노레포 단일 출처**.
 *
 * 왜 환경변수가 아니라 코드 상수인가:
 * - 이 값은 dev/stage/prod 로컬 어디서도 **달랐던 적이 없다**(전환 직전 실측:
 *   로컬 .env 8개 + dev-3 + dev-quiz + stage + prod 전부 동일). 환경별 주입이라는
 *   env 의 존재 이유가 성립하지 않는다.
 * - `NEXT_PUBLIC_*` 은 빌드타임에 인라인되므로 env 여도 런타임에 못 바꾼다.
 *   값을 바꾸려면 어차피 재빌드·재배포다 — env 의 유일한 이점이 무효.
 * - 이 값은 `libs/core/game` 의 `validateIFrameURL` 화이트리스트에 들어가는
 *   **보안 경계값**이다. 배포 설정으로 런타임 주입되는 것보다 코드로 리뷰를
 *   거치는 편이 안전하다.
 *
 * ⚠️ **반드시 path-scoped 접두어여야 한다.** bare 호스트(`https://zep.us`)로 두면
 * `validateIFrameURL` 이 그 도메인 전체를 iframe 허용하게 된다.
 *
 * 서빙 구조: S3 `zep-content-management-system` 버킷의 `cms/media/` 아래 객체가
 * CloudFront `/cms/*` behavior 를 통해 그대로 나간다. `rewrite-cms` 함수는
 * `/cms/{단일세그먼트}` 만 `contents/{id}/latest.json` 으로 재작성하고 나머지는
 * 원본 URI 를 통과시키므로 별도 인프라 설정이 필요 없다.
 */
export const CMS_MEDIA_BASE_URL = 'https://zep.us/cms/media';
